import { takeEvery, call, put } from 'redux-saga/effects'
import { buildGETUrl } from '../../../utilities/buildGETUrl'
import { EDIT_PLAYLIST, loading } from '../../../store/Modal/types/PlaylistCreate/actions'
import { closeModal } from '../../../store/Modal/actions'
import { loadPlaylists, updatePlaylist } from '../../../store/ContentPlaylists/actions'
import { showAlertError } from '../../../store/Alert/actions'
import { loadAvmapBindings } from '../../../store/ContentPlaylists/actions'
import axios from 'axios'
import { updatePublicPlaylistItem } from '../../../store/PublicPlaylists/actions'


export default function* () {
    yield takeEvery(EDIT_PLAYLIST, worker)
}

function* worker({ payload }) {
    console.log({ edit: payload });

    yield put(loading(true))
    try {
        let pay = { ...payload }
        delete pay.videolist
        delete pay.playlist
        let created = yield call(fetchEdit, pay)

        if (created.error) {
            yield put(showAlertError({
                errors: [`Ошибка сервера при ${EDIT_PLAYLIST}.`, created],
                text: "Плейлист не был изменен. Попробуйте повторить."
            }))
            yield put(closeModal("playlistEdit"))

        } else {

            if (payload.videolist) {
                //console.log("PEYLOAD", payload)
                let playlists = created.success.map(list => {
                    let totalsize2 = 0;
                    if (list.totalsize) {
                        let size = Math.floor(list.totalsize / 1024 / 1024);
                        size = !size ? `${Math.floor(list.totalsize / 1024)} Kb` : `${size} Mb`
                        totalsize2 = size
                    }
                    list.totalsize2 = totalsize2
                    return list;
                })
                console.log({ edit: created.success });

                yield call(fetchAvMapBindings, { owner_id: payload.owner_id, playlist_id: payload.id_playlist, videolist_id: payload.videolist })
            }
            yield put(closeModal("playlistEdit"))
            yield put(loadAvmapBindings())
            yield put(loadPlaylists())
            yield put(updatePublicPlaylistItem(payload))
        }
    }
    catch (e) {
        yield put(showAlertError({
            errors: [`Ошибка сети при ${EDIT_PLAYLIST}.`, e],
            text: "Плейлист не был изменен. Попробуйте повторить."
        }))
    }
    finally {
        yield put(loading(false))
    }
}

function fetchEdit(playlistData) {
    let formData = new FormData()
    let clear = { ...playlistData }
    if (!!playlistData['address'])
        delete playlistData['videolist']

    delete clear.id_playlist
    if (clear && clear.name) {
        Object.keys(clear).forEach(name => {
            formData.set(name, clear[name])
        })
    }

    return axios(
        {
            url: `/${!!playlistData['address'] ?  "stream" : "playlist" }/update?id=${playlistData.id_playlist}`,
            method: "POST",
            data: formData
        }
    )
        .then(response => response.data)
}
function fetchAvMapBindings(bindingData) {
    let formData = new FormData()
    console.log(bindingData)
    if (bindingData && bindingData.owner_id && bindingData.playlist_id && bindingData.videolist_id) {
        Object.keys(bindingData).forEach(name => {
            formData.set(name, bindingData[name])
        })
    }
    return axios(
        {
            url: "/videolist/avmap/insert",
            method: "POST",
            data: formData
        }
    )
        .then(response => response.jdata)
}